import { logosEnum } from "../enums/Logos"

export function getFestiveLogo(logo, variant) {
    if (logo && logo in logosEnum) {
        const variantsOfLogo = logosEnum[logo]
        if (variantsOfLogo && variant in variantsOfLogo) {
            return variantsOfLogo[variant]
        }
    }
}